import { createAction } from 'redux-actions';

export const modeRewind = createAction('mode/TOGGLED_REWIND');
export const modeBootUp = createAction('mode/BOOT_UP_COMPLETED');

export const modeChange = createAction('mode/MODE_CHANGED');

export const toggleRewind = createAction('mode/TOGGLED_REWIND');
export const bootUpComplete = createAction('mode/BOOT_UP_COMPLETED');
